import { Loadable } from '../../util/Loadable';
import { LinksAppState } from './types';

export const getArcadeUrl = (state: LinksAppState): Loadable<string | null> => state.links.arcadeUrl;
